const actions = {
  // Fetch List
  ORDER_FETCH_BEGIN: 'ORDER_FETCH_BEGIN',
  ORDER_FETCH_SUCCESS: 'ORDER_FETCH_SUCCESS',
  ORDER_FETCH_ERR: 'ORDER_FETCH_ERR',

  // Update Single Order
  ORDER_UPDATE_BEGIN: 'ORDER_UPDATE_BEGIN',
  ORDER_UPDATE_SUCCESS: 'ORDER_UPDATE_SUCCESS',
  ORDER_UPDATE_ERR: 'ORDER_UPDATE_ERR',

  orderFetchBegin: () => ({ type: actions.ORDER_FETCH_BEGIN }),

  orderFetchSuccess: (data, meta) => ({
    type: actions.ORDER_FETCH_SUCCESS,
    data,
    meta,
  }),

  orderFetchErr: (err) => ({
    type: actions.ORDER_FETCH_ERR,
    err,
  }),

  orderUpdateBegin: () => ({ type: actions.ORDER_UPDATE_BEGIN }),

  orderUpdateSuccess: (data) => ({
    type: actions.ORDER_UPDATE_SUCCESS,
    data,
  }),

  orderUpdateErr: (err) => ({
    type: actions.ORDER_UPDATE_ERR,
    err,
  }),
};

export const {
  ORDER_FETCH_BEGIN,
  ORDER_FETCH_SUCCESS,
  ORDER_FETCH_ERR,
  ORDER_UPDATE_BEGIN,
  ORDER_UPDATE_SUCCESS,
  ORDER_UPDATE_ERR,
} = actions;

export default actions;
